export default __webpack_public_path__ + "static/media/Bottom_assessment.4fa5900e.svg";